module.exports = __webpack_public_path__ + "img/logo-mgreward-en.798581df.svg";